import { render } from "./ThankyouView.vue?vue&type=template&id=5841afc8"
import script from "./ThankyouView.vue?vue&type=script&lang=js"
export * from "./ThankyouView.vue?vue&type=script&lang=js"

import "./ThankyouView.vue?vue&type=style&index=0&id=5841afc8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__